import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {CoreDI, CoreSettings, DeviceType} from '@gongxigames/framework/core';

export class InitDefaultModulesAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        await this.installer.initModules('default', this.getPlatform());
    }

    private getPlatform(): DeviceType {
        return this.installer.getComponent<CoreSettings>(CoreDI.Settings).get('platform');
    }

    getName(): string {
        return 'InitDefaultModulesAct';
    }
}